define(["./create"], function(create){
	// module:
	//		dojo/errors/RequestError

	/*=====
	 return function(){
		 // summary:
		 //		TODOC
	 };
	 =====*/

	return create("RequestError", function(message, response){
		this.response = response;
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/lib/dojo/errors/RequestError.js
// module id = 37
// module chunks = 0